module.exports = __webpack_public_path__ + "img/Delete_sidmenu_icon.f8ca9cd2.svg";